<template>
    <div class="mt-0">
        <div class="row p-2 mt-3" id="lower-div">
            <div class="card mb-4">
                <div v-loading="loading">
                    <Table @get-data="GetExceptionTypes" :data="data"></Table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Table from "./Components/Table.vue";

export default {
    components: {
        Table
    },
    data() {
        return {
            firstVis: true,
            loading: null,
            data: [
                {
                    id: 1,
                    exceptName: "İntihar (adətən müqavilənin ilk 12–24 ayı ərzində)",
                    created: "01.07.2025 14:32",
                    updated: "05.07.2025 10:15"
                },
                {
                    id: 2,
                    exceptName: "Müharibə, hərbi əməliyyatlar, terror aktları",
                    created: "02.07.2025 09:05",
                    updated: "06.07.2025 12:40"
                },
                {
                    id: 3,
                    exceptName: "Cinayət törədərkən ölüm",
                    created: "03.07.2025 17:22",
                    updated: "07.07.2025 08:55"
                },
                {
                    id: 4,
                    exceptName: "Alkoqol/narkotik sərxoşluğu",
                    created: "03.07.2025 17:22",
                    updated: "07.07.2025 08:55"
                }
            ], 
            navNumber: 1
        }
    },
    methods: {
        GetExceptionTypes() {
            
            //None
        }
    },
    mounted() {
        this.GetExceptionTypes()
    }
}
</script>